module.exports = __webpack_public_path__ + "img/transfer9.567d4d92.jpeg";